import { render, staticRenderFns } from "./TwitchLive.vue?vue&type=template&id=77918348&scoped=true&"
import script from "./TwitchLive.vue?vue&type=script&lang=js&"
export * from "./TwitchLive.vue?vue&type=script&lang=js&"
import style0 from "./TwitchLive.vue?vue&type=style&index=0&id=77918348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77918348",
  null
  
)

export default component.exports